module.exports = __webpack_public_path__ + "img/banner_UpCultura_utilzator_client_vn_200.2a8ef98d.png";